<template>
    <CompassMenu trigger="click">
        <CompassIconButton icon="action" />
        <template #dropdown>
            <template v-for="(action, index) in actions" :key="index">
                <CompassMenuGroup
                    v-if="action.childrens && action.childrens.length > 0"
                    :label="action.label"
                    placement="left-start"
                >
                    <template #dropdown>
                        <CompassMenuItem
                            v-for="(children, childIndex) in action.childrens"
                            :key="childIndex"
                            :disabled="!hasAccess(children.permission, permissions)"
                            :label="children.label"
                            @click="handleClick(children)"
                        />
                    </template>
                </CompassMenuGroup>
                <CompassMenuItem
                    v-else
                    :disabled="!hasAccess(action.permission, permissions)"
                    :label="action.label"
                    @click="handleClick(action)"
                />
            </template>
        </template>
    </CompassMenu>
</template>

<script>
import { hasAccess } from '../../helpers';
export default {
    props: {
        actions: {
            type: Array,
            required: true,
        },
        permissions: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    emits: ['clicked'],
    methods: {
        hasAccess,
        handleClick(action) {
            switch (action.type) {
                case 'link':
                    window.location.href = action.value;
                    break;
                case 'vuejs':
                    this.$emit('clicked', action.value);
                    break;
                default:
                    eval(action.value);
            }
        },
    },
};
</script>
